import FileRulesStore from '../FileRulesStore';
import { RULE_REC_TYPE } from '../../../../constants';

const SUPPORTED_FILE_TYPES = [
    'arj', 'csv', 'doc', 'docm', 'docx', 'dot', 'dotm', 'dotx', 'java', 'odp', 'ods', 'odt', 'pdf', 'perl',
    'pot', 'potm', 'potx', 'ppa', 'ppam', 'pps', 'ppsm', 'ppsx', 'ppt', 'pptm', 'pptx', 'py', 'rtf', 'sh',
    'sql', 'txt', 'xla', 'xlam', 'xlm', 'xls', 'xlsb', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx', 'zip'
];

export default class DlpRulesStore extends FileRulesStore {
    static PATH = '/console/dlp-rules';
    static PUBLIC_PATH = '/api/v3/dlp-rules';

    constructor(data = {}) {
        super({
            path: DlpRulesStore.PATH,
            supportedFileTypes: SUPPORTED_FILE_TYPES,
            type: RULE_REC_TYPE.DLP_RULES,
            ...data,
        });
    }
}
